import { render, staticRenderFns } from "./QuestionnaireIdentity.vue?vue&type=template&id=500e6e8f&scoped=true&"
import script from "./QuestionnaireIdentity.ts?vue&type=script&lang=ts&"
export * from "./QuestionnaireIdentity.ts?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireIdentity.scss?vue&type=style&index=0&id=500e6e8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e6e8f",
  null
  
)

export default component.exports